import { Link, useParams, useHistory } from 'react-router-dom';
import React, { useRef } from "react";
import { useDetectOutsideClick } from "./useDetectOutsideClick";
import { useUserSaved, useUserData } from '../../context/authContext'
import { useEventData } from '../../context/eventContext'
import './header.css';
import api from '../../services/api';
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCertificate, faEdit, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'


const Header: React.FC = () => {
    const { userSaved, setUserSaved } = useUserSaved()
    const { userData } = useUserData()
    const { eventData } = useEventData()
    const history = useHistory()
    const { eventKey } = useParams<{ eventKey: string }>();

    const { i18n, t } = useTranslation()

    const config = {
        headers: { Authorization: `Bearer ${userData.token}` }
    }
    const onExit = async () => {
        await api.get(`/sessions/logout/${userData.user.id}`, config);
        localStorage.removeItem('@userData')
        localStorage.removeItem('@userSaved')
        setUserSaved(false)
        history.push(`/${eventKey}/login`)
    }


    const handleChangeLanguage = (e: any, lang: string) => {
        e.preventDefault()
        i18n.changeLanguage(lang)
    }


    return (
        <header className="upper-container">
            <div className="wrapper hover_collapse">
                <div className="top_navbar">

                    <a className="logo" onClick={() => history.push(`/${eventKey}/login`)} style={{ cursor: 'pointer' }}>
                        <img height='40' src={eventData.customization.logo} alt="" />
                    </a>


                    <div className="menu">
                        <div

                            className="nav-btn lang-area"
                        >
                            <span>Idioma / Language:&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <a href="#" onClick={(e) => handleChangeLanguage(e, 'pt')} className="language-btn flag-pt-br">&nbsp;</a>
                            <a href="#" onClick={(e) => handleChangeLanguage(e, 'en')} className="language-btn flag-en">&nbsp;</a>
                            <a href="#" onClick={(e) => handleChangeLanguage(e, 'es')} className="language-btn flag-es">&nbsp;</a>
                        </div>

                        {userSaved ? (
                            <>
                                <div className=" profile_wrap">
                                    <div className="profile-container dropdown">
                                        <img src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLfn6eqrsbTp6+zg4uOwtrnJzc/j5earsbW0uby4vcDQ09XGyszU19jd3+G/xMamCvwDAAAFLklEQVR4nO2d2bLbIAxAbYE3sDH//7WFbPfexG4MiCAcnWmnrzkjIRaD2jQMwzAMwzAMwzAMwzAMwzAMwzAMwzAMwzAMwzAMw5wQkHJczewxZh2lhNK/CBOQo1n0JIT74/H/qMV0Z7GU3aCcVPuEE1XDCtVLAhgtpme7H0s1N1U7QjO0L8F7llzGeh1hEG/8Lo7TUmmuSrOfns9xnGXpXxsONPpA/B6OqqstjC6Ax/0ujkNdYQQbKNi2k64qiiEZ+ohi35X+2YcZw/WujmslYewiAliVYrxgJYrdwUmwXsU+RdApUi83oNIE27YvrfB/ZPg8+BJETXnqh9CVzBbTQHgojgiCvtqU9thFJg/CKz3VIMKMEkIXxIWqIpIg2SkjYj+xC816mrJae2aiWGykxRNsW0UwiJghJDljYI5CD8GRiCtIsJxizYUPQ2pzItZy5pcisTRdk/a9m4amtNNfBuQkdVhSaYqfpNTSFGfb9GRIakrE2Pm+GFLaCQPqiu0OpWP+HMPQQcgQMiQprWXNmsVwIjQjYi/ZrhAqNTCgr2gu0Jnz85RSSjso0HkMFZ0YZjKkc26a/jlmh9JiDyDxi9oeorTYAzZkwwoMz19pzj9bnH/GP/+qbchjSGflneWYhtTuKdMOmNKZcJ5TjInQKcYXnESd/jQxy0ENpULTNGOGgxpap/oyw9pbUAqhfx2Dbkhovvfgz4iUzoM9+GlK6/Mh4q29hyC1mwro30hpVVLPF9wYQr71RazOeM5/cw81iBRD+A03aM9/C/obbrKjbYSpCmIVG3qT/Q8oeUo3Rz0IL7vI1tEbCB9pSiu8I/aV8x3Kg/BGWrWp4ZVs0nZfmAoEG4h/61yHYIJiFSl6Q0Vk6tTW1N8kYp8hdOkfHYYMXd2Qft+8CYwqYDSKvqIh+MCF8Wgca2u/cwdgeW3TtuVn6+1oBs3yLo5C2JpK6CvQzGpfUkz9UG/87gCsi5o2LIXolxN0FbwAsjOLEr+YJmXn7iR6N0BCt5p5cMxm7eAsfS+/CACQf4CTpKjzgkvr2cVarVTf96372yut7XLJ1sa7lv6VcfgYrWaxqr3Wlo1S6pvStr22sxOtTNPLzdY3nj20bPP+ejFdJYkLsjGLdtPBEbe/mr2bQKiXWJDroA+vtzc0p9aahuwqHMDYrQEXHEw9jwQl3drMpts9JBU1SdktPe5FBRdJQ6bwXBpa57ib2A8kukQDzMjh++Uo7Fo6Wd02Pkf4fknqoo4HtvAIjsqUcjx6DIPgWCaOML9rKI/oqD9/lgNrn+eF+p7j8tnzHBiR7+kdUGw/+V1Kzkc75mMy6U+FMaxjPibiM1U1uGM+puInHpmALZCgP4pt7i840MV8+0R1zPsRB6UTcqpizncYwZ89syDydfyWCwXB1l8/zRNGWbTG/GHKUm9AkxHMc/EGSk3z2+ArEhPEV5TUBLEvUGFcjEUH80J/jveTGOAJEljJbILWGQT3zRYiwuKsUXN1EEJAzBhRJFll7mBUG7KD8EqPkKekBREaL8hMDZLQSG6AQjtHPYmvTQnX0TtpC1SYCe2YdkkyLP3jj5BSbKiuR585eQhTgoje6yIb0Yb0C+mV6EYvebqw5SDy2WmubogZiF2AVxPC2FpDf8H2Q9QWo6IkjUxTWVEI3WY/wrCeSuqJ+eRWzXR/JXwgVjUMozbCOfoEZiSiKVGepqv5CJ8RyR4D7xBeamqa7z3BJ/z17JxuBPdv93d/a2Ki878MMAzDMAzDMAzDMAzDMF/KP09VUmxBAiI3AAAAAElFTkSuQmCC'} className="profile-thumbnail" />

                                        <div className="profile-text">
                                            <h4>{userData.user.name}</h4>
                                            <p>{userData.user.email}</p>
                                        </div>
                                        <div className="dropdown-content">
                                            <Link to={`/${eventKey}/editprofile`}>
                                                <FontAwesomeIcon icon={faEdit} color={eventData.customization.theme_color} className="icon-Edit" />
                                                {` `}
                                              {t('header.editProfile')}
                                            </Link>

                                            <a style={{ cursor: 'pointer' }} className='cursor' onClick={onExit} >
                                                <FontAwesomeIcon icon={faSignOutAlt} color={eventData.customization.theme_color} className="icon-Edit" />
                                                {` `}
                                                {t('header.exit')}
                                            </a>
                                        </div>
                                    </div>

                                </div>

                            </>

                        ) : (
                            <>
                            </>
                            // <div

                            //     className="nav-btn lang-area"
                            //     style={{ maxWidth: "100%" }}>
                            //     <span>Idioma / Language:&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            //     <a href="#" onClick={(e) => handleChangeLanguage(e, 'pt-br')} className="language-btn flag-pt-br">&nbsp;</a>
                            //     <a href="#" onClick={(e) => handleChangeLanguage(e, 'en-us')} className="language-btn flag-en">&nbsp;</a>
                            //     <a href="#" onClick={(e) => handleChangeLanguage(e, 'es-es')} className="language-btn flag-es">&nbsp;</a>
                            // </div>
                        )}



                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
